import React from "react";

import { Skeleton } from '@mui/material';

import useStyles from "./styles";

interface Props {
  isLoading?: boolean;
  classesName?: string;
  children: React.ReactChild;
  isInput?: boolean;
  height?: number | string;
}

const SkeletonComponent = ({
  isLoading,
  classesName,
  children,
  isInput = false,
  height,
}: Props) => {
  const classes = useStyles();

  return isLoading ? (
    <Skeleton
      height={height}
      className={`${classes.skeleton} ${classesName || ""} ${isInput ? classes.inputSkeleton : ""}`}
    />
  ) : (
    <React.Fragment>{children}</React.Fragment>
  );
};

export default SkeletonComponent;
